<template>
  <div>
    <a v-model="linkToDownload" style="display: none"></a>
    <section class="content-header">
      <div v-if="!getClub.isAffilie"
           class="alert alert-warning alert-dismissible"
           style="margin-top: 0;">
        Attention! Votre club n'est actuellement pas licencié à l'A.B.F.T. pour l'année {{ currentYear() }}
      </div>
    </section>
    <section class="content">
      <div class="col-md-6 col-sm-12">
        <div class="portlet light ">
          <div class="portlet-title">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Données de contact</span>
              </div>
              <div class="subsubject">
                Mes données de contact
              </div>
            </div>
          </div>
          <div class="portlet-body">
            <div class="row">
              <div class="col-md-12">

                <div class="form-group" :class="{'has-error': errors.has('mail')}">
                  <label for="mail">Mail:</label>
                  <input v-validate="'email|max:255'"
                         class="form-control" name="mail" type="text"
                         v-model="getClub.mail" id="mail">
                </div>
                <!-- Telephone Form Input -->
                <div class="form-group" :class="{'has-error': errors.has('telephone')}">
                  <label for="telephone">Telephone:</label>
                  <input v-validate="'max:30'" class="form-control" name="telephone" type="text" v-model="getClub.tel" id="telephone">
                </div>
                <!-- Gsm Form Input -->
                <div class="form-group">
                  <label for="gsm">Gsm:</label>
                  <input v-validate="'max:30'" class="form-control" name="gsm" type="text" v-model="getClub.gsm" id="gsm">
                </div>

                <div class="checkbox" :class="{'has-error': errors.has('gsm')}">
                  <label class="checkbox-inline" style="font-weight: 400;">
                    <input id="affichage_correspondantTrue" type="checkbox"
                           v-model="affichage_donnees">
                    Afficher les données ci-dessus sur le site web.
                  </label>
                  <i class="fa fa-info-circle"
                     v-tooltip.top-center="`En cochant cette case, les données ci-dessus seront affichées sur notre site web à la place des données privées du correspondant de votre club`">
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="portlet light ">
          <div class="portlet-title">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Impressions</span>
                <span class="caption-helper"></span>
              </div>
              <div class="subsubject">
                Imprimer les documents officiels ABFT
              </div>
            </div>
          </div>
          <div class="portlet-body prints">
            <div class="row" v-if="courrierEnCours">
              <vue-simple-spinner
                :size="64"
                message="Chargement en cours..."
                :spacing="25"
                text-fg-color="#FFF"
                :font-size="16"

              ></vue-simple-spinner>
            </div>
            <div class="row" v-if="!courrierEnCours">
              <!--<div class="col-md-6">-->
              <!--<a class="btn btn-primary"-->
              <!--:disabled="!getClub.isAffilie || courrierEnCours" href="">Imprimer le document de composition club</a>-->
              <!--</div>-->
              <div class="col-md-6">
                <a class="btn btn-primary"
                   @click.prevent="downloadDocumentReconnaissance()"
                   :disabled="!getClub.isAffilie || courrierEnCours" href="">Imprimer le document de reconnaissance ABFT</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12">
        <div class="portlet light ">
          <div class="portlet-title">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Votre club</span>
              </div>
              <div class="subsubject">
                Fiche administrative
              </div>
            </div>
          </div>
          <div class="portlet-body">
            <div class="row">
              <div class="col-md-12">

                <div class="form-group">
                  <label>Numéro de club:</label>
                  <input readonly="1" class="form-control" type="text" v-model="getClub.numero_club">
                </div>
                <div class="form-group">
                  <label>Province:</label>
                  <input readonly="1" class="form-control" type="text" v-model="getClub.province">
                </div>
                <div class="form-group">
                  <label>Club:</label>
                  <input readonly="1" class="form-control" type="text" v-model="getClub.club">
                </div>
                <div class="form-group">
                  <label>Adresse:</label>
                  <input readonly="1" class="form-control" type="text" v-model="getClub.adresse">
                </div>

                <div class="form-group">
                  <label>Code postal:</label>
                  <input readonly="1" class="form-control" type="text" v-model="getClub.cp">
                </div>

                <div class="form-group">
                  <label>Ville:</label>
                  <input readonly="1" class="form-control" type="text" v-model="getClub.ville">
                </div>

                <div class="form-group">
                  <label>Numéro de compte:</label>
                  <input readonly="1" class="form-control" type="text" v-model="getClub.numero_compte">
                </div>

                <div class="form-group" :class="{'has-error': errors.has('site_web')}">
                  <label>Site web :</label>
                  <input class="form-control" type="text"
                         name="site_web"
                         v-validate="{url: {require_protocol: true },max:1000}"
                         v-model="getClub.site_web">
                  <div class="helper text-warning mt-2" style="margin-top: 5px; margin-left: 5px;"
                       v-if="errors.has('site_web')">('http://' ou 'https://' requis)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="col-md-12">
          <div class="row">
            <input
              :disabled="errors.count()!=0 || !getClub.rights.write"
              @click.prevent="saveClub()"
              class="btn btn-primary pull-right btnSave"
              type="submit"
              value="Sauvegarder">
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="portlet light">
          <div class="portlet-title" :style="{ 'min-height': hasPrevious2007(getLicences()) ? '48px':'32px' }">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Mes affiliations</span>
                <span class="caption-helper"></span>
              </div>
              <div class="subsubject" v-if="hasPrevious2007(getLicences())">
                Pour des raisons techniques, les données antérieures à l'année 2007 ne peuvent être garanties.
              </div>
            </div>
          </div>
          <div class="portlet-body">
            <table class="table table-responsive table-hover">
              <thead>
              <tr>
                <th>Année</th>
                <th>En ordre de licence ?</th>
                <!--<th>Payement de la cotisation</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-if="!getClub.isAffilie && getClub.rights.can_register_member && isDev()">
                <th>{{ currentYear() }}</th>
                <td>
                  <span class="text-danger text-uppercase"><strong>NON</strong></span>
                  <span v-if="!isAlreadyInCart(getClub.id)" class="btn btn-warning" style="margin-left: 30px;" @click.prevent="addToCartFct()">
                    Commander votre licence club en ligne</span>
                  <span v-if="isAlreadyInCart(getClub.id)" disabled class="btn btn-warning" style="margin-left: 30px;" >Déjà dans votre panier</span>
                </td>
              </tr>
              <tr v-for="licence in getLicences()">
                <th>{{ licence['annee'] }}</th>
                <td>
                  <span v-if="licence['inscription'] && licence['payement']" class="text-success text-uppercase"><strong>OUI</strong></span>
                  <span v-else class="text-danger text-uppercase"><strong>NON</strong></span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import Auth from '@/auth'
import moment from 'moment/moment'
import {mapGetters, mapActions} from 'vuex'
let _ = require('lodash')
let FileSaver = require('file-saver');

export default {
  data() {
    return {
      formErrors: [],
      courrierEnCours: false,
      linkToDownload: "",
      affichage_donnees: false
    }
  },
  watch: {
    'affichage_donnees': function () {
      this.getClub.affichage_correspondant = !this.affichage_donnees
    }
  },
  mounted: function () {
    this.affichage_donnees = !this.getClub.affichage_correspondant;
  },
  methods: {
    ...mapActions({
      setLoading: 'setLoading',
      setClub: 'setClub',
      removeFromCart: 'removeFromCart',
      addToCart: 'addToCart'
    }),
    isDev: function () {
      return process.env.NODE_ENV === 'development'
    },
    isAlreadyInCart: function (id) {
      return _.has(this.getCart, 'licence_club')
        && _.has(this.getCart.licence_club, id)
    },
    addToCartFct: function (item) {

      this.removeFromCart({id:this.getClub.id,type:'licence_club'})
      let product = {
        type: 'licence_club',
        club: this.getClub.club,
        id: this.getClub.id,
        quantity: 1
      }
      this.addToCart(product)
      this.$noty.success("Votre licence club a été ajoutée à votre panier")
    },

    saveClub() {
      this.setLoading(true)
      let saveRequest = {
        "id_club": this.getClub.id,
        "tel": this.getClub.tel,
        "mail": this.getClub.mail,
        "gsm": this.getClub.gsm,
        "site_web": this.getClub.site_web,
        "affichage_correspondant": this.getClub.affichage_correspondant,
      };
      this.$http.post(process.env.API_URL + "saveInfosClub", saveRequest)
        .then((response) => {
          this.setLoading(false)
          this.setClub(response.body)
          this.$noty.success("Les données de votre club ont été enregistrées.")
        }, (response) => {
          this.setLoading(false)
          this.$noty.error("Erreur lors de la sauvegarde des données.")
        })
    },
    hasPrevious2007(table) {
      return _.find(table, function (item) {
        return item.annee < 2007
      })
    },
    downloadDocumentReconnaissance: function () {
      let these = this
      this.courrierEnCours = true
      return this.$http.post
      (
        process.env.API_URL + "getDocumentReconnaissanceABFT",
        JSON.stringify({"id_club": these.getClub.id}),
        {responseType: 'blob'}
      ).then(function (response) {
        these.courrierEnCours = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, "Attestation.pdf");
        return response.blob();
      }, (response) => {
        these.$noty.error("L'attestation n'a pas pu être créée")
        these.courrierEnCours = false
      })
    },
    currentYear: function () {
      return moment().year();
    },
    getLicences() {
      return _.sortBy(this.getClub.licences, 'annee').reverse()
    },
  },
  components: {},
  computed: {
    ...mapGetters({
      getClub: 'getClub',
      getCart: 'getCart',
      getRoutes: 'getRoutes',
      getLoading: 'getLoading'
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Club/ClubProfile.vue